module.exports = __webpack_public_path__ + "static/media/positive.ba172dcc.png";